import Vue from "vue";

export const SHOW_BLOCK_OVERLAY = "SHOW_BLOCK_OVERLAY";
export const HIDE_BLOCK_OVERLAY = "HIDE_BLOCK_OVERLAY";

export const blockOverlayEventBus = new Vue();